import { isObject, isEmpty } from 'lodash';
import * as types from '../../actions/actionTypes';
import { cloneState } from '../../helpers/stateHelper';
import LocalStorage from '../../helpers/storage/LocalStorage';

const INITSTATE = {
    showSearchInput: true,
    what: '',
    headerTextQuery: '',
    where: '',
    lat: null,
    lng: null,
    map_center_lat: null,
    map_center_lng: null,
    radius: null,
    placeid: null,
    placename: null,
    start: null,
    sort: null,
    size: null,
    checkin_time: null,
    checkout_time: null,
    highlighted_item: -1,
    uiFilters: {
        hasFilters: false,
        accommodations: {},
        campsiteUseTypes: {},
        campsiteTypes: {},
        campsiteAmenities: {},
        campsiteElectricityHookup: {},
        campsiteVehicleLength: {},
        campsiteEquipment: {},
        activities: {},
        occupants: {},
        inventoryTypes: {},
        tourTypes: {},
        tourAccessible: {},
        tourDifficulty: {},
        tourDuration: {},
        tourPrice: {},
        tourTime: {},
        permitTypes: {},
        reservable: {},
        lastAppliedFilter: null,
        includeUnavailable: true,
    },
    inventoryTypeFiltersVisible: false,
    filtersVisible: false,
    filters: [],
    aggregations: [],
};

// check if any of the ui filters are set
function checkUIFiltersPresent(state) {
    for (const propName in state.uiFilters) {
        if (isObject(state.uiFilters[propName])) {
            if (!isEmpty(state.uiFilters[propName])) {
                return true;
            }
        }
    }
    return false;
}

// Store the persistent state props
const setStorage = (state) => {
    let st = state;
    if (!st) {
        st = {};
    }
    st.last_updated_datetime = new Date().getTime();
    if (LocalStorage) {
        try {
            LocalStorage.setItem('r1s_search_session', JSON.stringify(st));
        } catch (e) {
            // do nothing
        }
    }
    return st;
};

export default function search(state = INITSTATE, action) {
    let st = state;
    let filterOptions = null;

    switch (action.type) {
        case types.UPDATE_CHECKIN_DATE:
            st = cloneState(state);
            st.checkin_time = action.time;
            delete st.err;
            return setStorage(st);

        case types.UPDATE_CHECKOUT_DATE:
            st = cloneState(state);
            st.checkout_time = action.time;
            delete st.err;
            return setStorage(st);

        case types.UPDATE_SEARCH_CRITERIA:
            st = cloneState(state);
            st[action.name] = action.value;
            return setStorage(st);

        case types.UPDATE_SEARCH_CRITERIAS:
            st = cloneState(state);
            st = Object.assign({}, st, action);
            return setStorage(st);

        case types.ADD_SEARCH_FILTER:
            st = cloneState(state);
            filterOptions = st.uiFilters[action.uiFilterName];
            filterOptions[action.uiFilterOption.key] = action.uiFilterOption;
            st.uiFilters[action.uiFilterName] = filterOptions;
            st.uiFilters.hasFilters = true;
            st.uiFilters.lastAppliedFilter = action.uiFilterName;
            st.start = 0;
            return setStorage(st);

        case types.SET_SEARCH_FILTER:
            st = cloneState(state);
            filterOptions = {};
            filterOptions[action.uiFilterOption.key] = action.uiFilterOption;
            st.uiFilters[action.uiFilterName] = filterOptions;
            st.uiFilters.hasFilters = true;
            st.uiFilters.lastAppliedFilter = action.uiFilterName;
            st.start = 0;
            return setStorage(st);

        case types.REMOVE_SEARCH_FILTER:
            st = cloneState(state);
            filterOptions = st.uiFilters[action.uiFilterName];
            delete filterOptions[action.uiFilterOption.key];
            st.uiFilters[action.uiFilterName] = filterOptions;
            st.uiFilters.hasFilters = checkUIFiltersPresent(st);
            st.uiFilters.lastAppliedFilter = action.uiFilterName;
            st.start = 0;
            return setStorage(st);

        case types.RESET_SEARCH_FILTERS:
            st = cloneState(state);
            st.filters = [];
            st.include_unavailable = true;
            st.include_notreservable = true;
            st.include_partially_available = true;
            st.start = 0;
            st.uiFilters = {
                hasFilters: false,
                campsiteUseTypes: {},
                campsiteTypes: {},
                campsiteAmenities: {},
                campsiteElectricityHookup: {},
                campsiteVehicleLength: {},
                campsiteEquipment: {},
                activities: {},
                occupants: {},
                inventoryTypes: {},
                tourTypes: {},
                tourAccessible: {},
                tourDifficulty: {},
                tourDuration: {},
                tourPrice: {},
                tourTime: {},
                permitTypes: {},
                reservable: {},
                lastAppliedFilter: null,
            };
            st.highlighted_item = -1;
            return setStorage(st);

        case types.RESET_SEARCH_FILTERS_CAMPSITES:
            st = cloneState(state);
            st.include_unavailable = true;
            st.include_notreservable = true;
            st.include_partially_available = true;
            st.start = 0;
            st.uiFilters.campsiteUseTypes = {};
            st.uiFilters.campsiteTypes = {};
            st.uiFilters.campsiteAmenities = {};
            st.uiFilters.campsiteElectricityHookup = {};
            st.uiFilters.campsiteVehicleLength = {};
            st.uiFilters.campsiteEquipment = {};
            st.uiFilters.occupants = {};
            st.uiFilters.reservable = {};
            st.highlighted_item = -1;
            return setStorage(st);

        case types.HIGHLIGHT_SEARCH_RESULT_ITEM:
            st = cloneState(state);
            st.highlighted_item = action.payload;
            delete st.err;
            return setStorage(st);

        case types.HIDE_SEARCH_INPUT:
            st = cloneState(state);
            st.showSearchInput = false;
            delete st.err;
            return setStorage(st);

        case types.SHOW_SEARCH_INPUT:
            st = cloneState(state);
            st.showSearchInput = true;
            delete st.err;
            return setStorage(st);

        default:
            return st;
    }
}
